import { helper } from '@ember/component/helper';

import { parseDate } from 'rise-ui/utils/date.js';

export default helper(function qpDateObjectHelper([ date, keyPos ], { key }) {
  if (Array.isArray(date)) {
    date = date[0];
  }
  key = key || keyPos;
  if (date && key) {
    date = date[key];
  }
  return parseDate(date, 'url');
});
